<mat-horizontal-stepper linear="true">
    <mat-step *ngIf="configurationVisible" [completed]="configuracionCompleted">
        <ng-template matStepLabel>Configuración</ng-template>
        <mat-spinner *ngIf="loading" [diameter]="50"></mat-spinner>
        <div class="configuration" *ngIf="isBillingExportImages && !loading">
            <form [formGroup]="formExportImages">
                <mat-form-field class="medium-width margin-right-small">
                    <mat-select placeholder="Tipo de imágenes" formControlName="MedicalOrderScannTypes" multiple>
                        <mat-select-trigger>
                            {{fExportImages.MedicalOrderScannTypes.value?.length > 0 ? fExportImages.MedicalOrderScannTypes.value[0].Name : ''}}
                            <span *ngIf="fExportImages.MedicalOrderScannTypes.value?.length > 1" class="additional-selection">
                              (+{{fExportImages.MedicalOrderScannTypes.value.length - 1}} {{fExportImages.MedicalOrderScannTypes.value?.length === 2 ? 'otro' : 'otros'}})
                            </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let medicalOrderScannType of medicalOrderScannTypes" [value]="medicalOrderScannType">
                            {{ medicalOrderScannType.Name }}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="fExportImages.MedicalOrderScannTypes.errors && 
                                        fExportImages.MedicalOrderScannTypes.errors.required">
                        Ingrese algún tipo de imagén
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
        <div class="configuration" *ngIf="isBillingPreBilling && !loading">
            <form [formGroup]="formPreBilling">
                <div formArrayName="BillingClosePreBillings">
                    <div *ngFor="let item of billingClosePreBillingsArrayGroup.controls; let i=index" [formGroupName]="i">
                        <mat-form-field class="medium-width margin-right-small">
                            <input matInput formControlName="BillingGroupName">
                        </mat-form-field>
                        <mat-form-field class="medium-width">
                            <mat-label>Período</mat-label>
                            <mat-select formControlName="SelectedBillingClosePeriod" name="SelectedBillingClosePeriod">
                                <mat-option *ngFor="let billingClosePeriod of getBillingClosePeriod(i)" [value]="billingClosePeriod">
                                    {{ billingClosePeriod.Name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </form>
        </div>
        <button type="button" (click)="cancel()" mat-button>CANCELAR</button>
        <button type="button" mat-button matStepperNext>SIGUIENTE</button>
    </mat-step>
    <mat-step [completed]="taskCompleted">
        <form (submit)="finish()" [formGroup]="formTask">
            <ng-template matStepLabel>Tarea programada</ng-template>
            <mat-form-field class="medium-width margin-right-small">
                <mat-label>Nombre</mat-label>
                <input matInput placeholder="Nombre de la tarea" formControlName="name" required>
                <mat-error *ngIf="f.date.errors && f.date.errors.required">
                    Ingrese el nombre de referencia
                </mat-error>
            </mat-form-field>
            <mat-form-field class="medium-width">
                <input matInput autocomplete="off" formControlName="date" [matDatepicker]="pickerDate" placeholder="Fecha ejecución" required>
                <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                <mat-datepicker #pickerDate></mat-datepicker>
                <mat-error *ngIf="f.date.errors && f.date.errors.required">
                    Ingrese la fecha desde
                </mat-error>
            </mat-form-field>
            <mat-form-field class="medium-width margin-right-small">
                <mat-label>Hora</mat-label>
                <mat-select formControlName="hour" name="hour" required>
                    <mat-option *ngFor="let hour of hours" [value]="hour">
                        {{ hour }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="f.hour.errors && f.hour.errors.required">
                    Ingrese la hora
                </mat-error>
            </mat-form-field>
            <mat-form-field class="medium-width">
                <mat-label>Minutos</mat-label>
                <mat-select formControlName="minute" name="minute" required>
                    <mat-option *ngFor="let minute of minutes" [value]="minute">
                        {{ minute }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="f.minute.errors && f.minute.errors.required">
                    Ingrese los minutos
                </mat-error>
            </mat-form-field>
            <mat-spinner [diameter]="50" *ngIf="loadingAction"></mat-spinner>
            <button *ngIf="!loadingAction" type="button" (click)="cancel()" mat-button>CANCELAR</button>
            <button *ngIf="!loadingAction && configurationVisible" type="button" mat-button matStepperPrevious>ANTERIOR</button>
            <button *ngIf="!loadingAction" type="submit" mat-button matStepperNext>FINALIZAR</button>
            <button *ngIf="isBillingPreBilling && !loadingAction" type="button" (click)="preBilling()" mat-button>EJECUTAR AHORA</button>
        </form>

    </mat-step>
</mat-horizontal-stepper>